module.exports = __webpack_public_path__ + "static/media/main30.daa94f2f.png";